import axios from '../../config/axios.js'
import store from '../../vuex/store.js'
import { addIso690 } from '../../custom/function.js'

const STATE = {

    masterpieces: [],
    masterpiece: {},
    documents: [],
    fork_proj_id: null,
    mp_image: null,
    image_existed: false,

}

const GETTERS = {

    masterpieces: state => state.masterpieces,
    masterpiece: state => state.masterpiece,
    documents: state => state.documents,
    fork_proj_id: state => state.fork_proj_id,
    mp_image: state => state.mp_image,
    image_existed: state => state.image_existed,

}

const MUTATIONS = {

    getMasterpieces(state, masterpieces) {
        state.masterpieces = masterpieces
    },

    getMasterpiece(state, masterpiece) {
        state.masterpiece = masterpiece
    },

    getDocuments(state, documents) {
        state.documents = documents
    },

    forkMasterpiece(state, payload) {
        state.fork_proj_id = payload.project.proj_id
    },

    getMasterpieceImage(state, payload) {
        state.mp_image = payload.image
        state.image_existed = payload.result
    },

    removeMasterpieceImage(state) {
        state.mp_image = null
        state.image_existed = false
    },

}

const ACTIONS = {

    async getMasterpieces({ commit }) {
        await axios.ACCESS.get('/api/bt/masterpieces')
            .then(res => {
                // console.log('gallery/getMasterpieces', res)
                if (res.data.result) {
                    commit('getMasterpieces', res.data.masterpieces)
                } else { throw new Error(res.data) }
            })
    },

    async getMasterpiece({ commit, dispatch }, mp_id) {
        await axios.ACCESS.get('/api/masterpiece/' + mp_id)
            .then(res => {
                // console.log('gallery/getMasterpiece', res)
                if (res.data.result) {
                    commit('getMasterpiece', res.data.masterpiece)
                    dispatch('getDocuments', mp_id)
                } else { throw new Error(res.data) }
            })
    },

    async getDocuments({ commit }, mp_id) {
        await axios.ACCESS.get('/api/bt/masterpiece/' + mp_id + '/documents')
            .then(res => {
                // console.log('gallery/getDocuments', res)
                if (res.data.result) {
                    addIso690(res.data.documents)
                        .then(res => {
                            commit('getDocuments', res)
                        })
                } else { throw new Error(res.data) }
            })
    },

    async forkMasterpiece({ commit }, payload) {
        await axios.ACCESS.post('/api/masterpiece/' + payload.mp_id + '/fork', {
                title: payload.title,
                description: payload.description,
                mode: payload.mode,
            })
            .then(res => {
                // console.log('gallery/forkMasterpiece', res)
                if (res.data.result) {
                    commit('forkMasterpiece', res.data)
                } else { throw new Error(res.data) }
            })
    },

    async voteMasterpiece({ dispatch }, payload) {
        await axios.ACCESS.post('/api/masterpiece/' + payload.mp_id + '/vote', {
                action: payload.action
            })
            .then(res => {
                // console.log('gallery/voteMasterpiece', res)
                dispatch('getMasterpiece', payload.mp_id)
            })
    },

    async voteDocument({ dispatch }, payload) {
        await axios.ACCESS.post('/api/masterpiece/' + payload.mp_id +
                '/document/' + payload.doc_key + '/vote', {
                    action: payload.action
                })
            .then(res => {
                // console.log('gallery/voteDocument', res)
                dispatch('getDocuments', payload.mp_id)
            })
    },

    async getMasterpieceImage({ commit }, id) {
        await axios.ACCESS.get('/api/masterpiece/' + id + '/image', {
                responseType: 'arraybuffer',
            })
            .then(res => {
                // console.log('gallery/getMasterpieceImage', res)
                let mp_image = null
                if (res) {
                    let image = btoa(
                        new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    )
                    mp_image = `data:${res.headers['content-type'].toLowerCase()};base64,${image}`
                }
                commit('getMasterpieceImage', {
                    image: mp_image,
                    result: !!res,
                })
            })
    },

    async forkMPImage({ commit }, payload) {
        await axios.ACCESS.get('/api/masterpiece/' + payload.mp_id + '/image', {
                responseType: 'arraybuffer',
            })
            .then(res => {
                // console.log('gallery/forkMPImage', res)

                function dataURLtoFile(dataurl, filename) {
                    var arr = dataurl.split(','),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new File([u8arr], filename, { type: mime });
                }

                let mp_image = null
                if (res) {
                    let image = btoa(
                        new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    )
                    mp_image = `data:${res.headers['content-type'].toLowerCase()};base64,${image}`
                }
                let form_data = new FormData()
                form_data.append('image', dataURLtoFile(mp_image, 'img.png'))
                store.dispatch('project/setProjectImage', {
                    proj_id: payload.proj_id,
                    form_data,
                })
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/gallery.js